export var chains={
    0:"",
    1:"locket",
    2:"magical locate",
    3:"iron chain"
}

export var eyeglasses={
    0:"",
    1:"aviator sunglass",
    2:"plain square sunglass",
    3:"round sunglass",
    4:"square sunglass",
    5:"transparent round sunglass"
}

export var hats={
    0:"",
    1:"bamboo hat",
    2:"birthday hat",
    3:"cap",
    4:"chef cap",
    5:"cowboy hat",
    6:"degree hat"
}

export var leftHands={
    0:"",
    1:"baburao telephone",
    2:"baseball ball",
    3:"basketball",
    4:"boomerang",
    5:"bread",
    6:"camera",
    7:"candy",
    8:"chocolate bar",
    9:"coffee cup",
    10:"colddrink can",
    11:"conical empty flask",
    12:"conical flask",
    13:"diamond",
    14:"donut",
    15:"dumbbells",
    16:"flute",
    17:"game remote",
    18:"hairbrush",
    19:"icecream cone",
    20:"idea",
    21:"landline phone",
    22:"laptop",
    23:"lighting 1",
    24:"lighting 2",
    25:"lock",
    26:"lollipop",
    27:"magic lock",
    28:"magic stick",
    29:"mike",
    30:"mushroom",
    31:"orange icecream bar",
    32:"round bottom flask",
    33:"round diamond",
    34:"square diamond",
    35:"telescope",
    36:"torch",
    37:"trumpet",
    38:"victory cup",
    39:"watermelon slice",
    40:"wine glass 1",
    41:"wine glass 2",
    42:"wine glass 3",
    43:"writing pad"
}


export var rightHands={
    0:"",
    1:"american football",
    2:"axe",
    3:"bag",
    4:"balloon",
    5:"baseball bat",
    6:"beer bottle",
    7:"big hammer",
    8:"botal",
    9:"box",
    10:"broom",
    11:"degree scroll",
    12:"double sided axe",
    13:"egg",
    14:"football",
    15:"hammer",
    16:"keyboard",
    17:"lamp 1",
    18:"lamp 2",
    19:"lamp 3",
    20:"magic wand",
    21:"mail",
    22:"package courier",
    23:"paint bucket",
    24:"pillow",
    25:"pot",
    26:"shank",
    27:"sleeping bag",
    28:"small tree pot",
    29:"snow",
    30:"special egg",
    31:"tiffin bag",
    32:"volleyball",
    33:"watermelon",
    34:"wine bottle",
}


// Commented data
/*

var leftHands={
    0:"",
    // Foodie     
    1:"bread",
    2:"candy",
    3:"chocolate bar",
    4:"coffee cup",
    5:"colddrink can",
    6:"donut",
    7:"icecream cone",
    8:"lollipop",
    9:"mushroom",
    10:"orange icecream bar",
    11:"watermelon slice",
    // Mystical
    12:"diamond",
    13:"lighting 1",
    14:"lighting 2",
    15:"magic lock",
    16:"magic stick",
    17:"round diamond",
    18:"square diamond",
    // Techie
    19:"camera",
    20:"game remote",
    21:"landline",
    22:"laptop",
    // Fighters
    23:"dumbbells",
    24:"wine glass 1",
    25:"wine glass 2",
    26:"wine glass 3",
    // Scholar
    27:"conical empty flask",
    28:"conical flask",
    29:"round bottom flask",
    30:"idea",
    31:"writing pad",
    // Sports
    32:"baseball ball",
    33:"basketball",
    34:"boomerang",
    35:"victory cup",
    // Musical
    36:"flute",
    37:"trumpet",
    38:"mike",
    // Normal
    39:"baburao telephone",
    40:"lock",
    41:"torch",
    42:"hairbrush",
    43:"telescope"
}

var rightHands={
    0:"",
    // Foodie     
    1:"botal",
    2:"egg",
    3:"tiffin bag",
    4:"watermelon",
    
    // Mystical
    5:"pot",
    6:"snow",
    7:"special egg",
    8:"magic wand",

    // Techie
    9:"keyboard",
    // Fighters
    10:"axe",
    11:"big hammer",
    12:"double sided axe",
    13:"hammer",
    14:"beer bottle",
    15:"wine bottle",
    // Scholar
    16:"degree scroll",
    17:"mail",
    // Sports
    18:"american football",
    19:"football",
    20:"volleyball",
    21:"baseball bat",
    // Musical
    22:"shank",
    // Normal
    23:"bag",
    24:"balloon",
    25:"box",
    26:"broom",
    27:"lamp 1",
    28:"lamp 2",
    29:"lamp 3",
    30:"package courier",
    31:"paint bucket",
    32:"pillow",
    33:"sleeping bag",
    34:"small tree pot",
}


*/

var mysticalChains=[1,2]
var mysticalEyeglass=[]
var mysticalHats=[]
var mysticalLeftHands=[13,23,24,27,28,33,34]
var mysticalRightHands=[20,25,29,30]

var techieChains=[]
var techieEyeglass=[4]
var techieHats=[]
var techieLeftHands=[6,17,21,22]
var techieRightHands=[16]

var fightersChains=[3]
var fightersEyeglass=[1]
var fightersHats=[1]
var fightersLeftHands=[15,40,41,42]
var fightersRightHands=[2,6,7,12,15,34]

var scholarChains=[]
var scholarEyeglass=[5]
var scholarHats=[6]
var scholarLeftHands=[11,12,20,32,43]
var scholarRightHands=[11,21]

var sportsChains=[]
var sportsEyeglass=[]
var sportsHats=[3]
var sportsLeftHands=[2,3,4,38]
var sportsRightHands=[1,5,14,32]

var musicalChains=[]
var musicalEyeglass=[2]
var musicalHats=[2]
var musicalLeftHands=[16,29,37]
var musicalRightHands=[26]

var foodieChains=[] 
var foodieEyeglass=[4] 
var foodieHats=[4] 
var foodieLeftHands=[5,7,8,9,10,14,19,26,30,31,39] 
var foodieRightHands=[8,13,31,33] 

var normalChains=[]
var normalEyeglass=[2]
var normalHats=[2]
var normalLeftHands=[1,18,25,35,36]
var normalRightHands=[3,4,9,10,17,18,19,22,23,24,27,28]

/* Generation Order
    Mystical    1
    Techie      2
    Fighters    3
    Scholar     4
    Sports      5
    Musical     6
    Foodie      7
    Normal      8
 */

export function getGeneration(chainId, eyeglassId, hatId, lefthandId, righthandId){

    var gen=[0,0,0,0,0,0,0,0,0,0];
    //chainId
    if(mysticalChains.includes(chainId))
        gen[1]++;
    if(techieChains.includes(chainId))
        gen[2]++;
    if(fightersChains.includes(chainId))
        gen[3]++;
    if(scholarChains.includes(chainId))
        gen[4]++;
    if(sportsChains.includes(chainId))
        gen[5]++;
    if(musicalChains.includes(chainId))
        gen[6]++;
    if(foodieChains.includes(chainId))
        gen[7]++;
    if(normalChains.includes(chainId))
        gen[8]++;    
    
    //Eyeglass
    if(mysticalEyeglass.includes(eyeglassId))
        gen[1]++;
    if(techieEyeglass.includes(eyeglassId))
        gen[2]++;
    if(fightersEyeglass.includes(eyeglassId))
        gen[3]++;
    if(scholarEyeglass.includes(eyeglassId))
        gen[4]++;
    if(sportsEyeglass.includes(eyeglassId))
        gen[5]++;
    if(musicalEyeglass.includes(eyeglassId))
        gen[6]++;
    if(foodieEyeglass.includes(eyeglassId))
        gen[7]++;
    if(normalEyeglass.includes(eyeglassId))
        gen[8]++; 
    
    //Hat
    if(mysticalHats.includes(hatId))
        gen[1]++;
    if(techieHats.includes(hatId))
        gen[2]++;
    if(fightersHats.includes(hatId))
        gen[3]++;
    if(scholarHats.includes(hatId))
        gen[4]++;
    if(sportsHats.includes(hatId))
        gen[5]++;
    if(musicalHats.includes(hatId))
        gen[6]++;
    if(foodieHats.includes(hatId))
        gen[7]++;
    if(normalHats.includes(hatId))
        gen[8]++;  

    //Left Hand
    if(mysticalLeftHands.includes(lefthandId))
        gen[1]++;
    if(techieLeftHands.includes(lefthandId))
        gen[2]++;
    if(fightersLeftHands.includes(lefthandId))
        gen[3]++;
    if(scholarLeftHands.includes(lefthandId))
        gen[4]++;
    if(sportsLeftHands.includes(lefthandId))
        gen[5]++;
    if(musicalLeftHands.includes(lefthandId))
        gen[6]++;
    if(foodieLeftHands.includes(lefthandId))
        gen[7]++;
    if(normalLeftHands.includes(lefthandId))
        gen[8]++;  
    
    //Right Hand
    if(mysticalRightHands.includes(righthandId))
        gen[1]++;
    if(techieRightHands.includes(righthandId))
        gen[2]++;
    if(fightersRightHands.includes(righthandId))
        gen[3]++;
    if(scholarRightHands.includes(righthandId))
        gen[4]++;
    if(sportsRightHands.includes(righthandId))
        gen[5]++;
    if(musicalRightHands.includes(righthandId))
        gen[6]++;
    if(foodieRightHands.includes(righthandId))
        gen[7]++;
    if(normalRightHands.includes(righthandId))
        gen[8]++;  
    
    let result="";
    // console.log(gen);
    // console.log(Math.max(...gen));
    // console.log(gen.indexOf(Math.max(...gen)));
    switch(gen.indexOf(Math.max(...gen))){
        case 1: result="Mystical";
                break;
        case 2: result="Techie";
                break;
        case 3: result="Fighters";
                break;
        case 4: result="Scholar";
                break;
        case 5: result="Sports";
                break;
        case 6: result="Musical";
                break;
        case 7: result="Foodie";
                break;
        case 8: result="Normal";
                break;
    }
    
    return result;
}
